import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (8 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisFirma = {

  CreateMerchantManually(token, name, lastname, email, phone, countryCode, role, password, corporationID, companyTitle, tckn) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-user-merchant-manually`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        name,
        lastname,
        email,
        phone,
        countryCode,
        role,
        password,
        corporationID,
        companyTitle,
        tckn
      },
    });
  },

  UserResetPasswordByMerchant(token, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/user-reset-password-by-merchant`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID
      }
    });
  },

  CheckCompanyDocumentsComplete(token, { signal } = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/check-company-documents-complete`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      signal
    });
  },

  // Firma kaşesi: görsel olarak yüklenir (logo ile aynı akış), sözleşmede imzanın altında görünür.
  // NOT: KULLANIM DIŞI. Kaşe artık otomatik üretilir (GenerateCompanyStamp) ve firma onaylar
  // (ApproveCompanyStamp). Bu uç geriye dönük uyumluluk için duruyor; backend hata döndürür.
  SaveCompanyStamp(token, file, companyID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/save-company-stamp`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { file, ...(companyID ? { companyID } : {}) }
    });
  },

  // Kaşeyi firmanın kayıtlı resmi ad/adres/vergi bilgisinden OTOMATİK üretir (firma onayını sıfırlar).
  GenerateCompanyStamp(token, companyID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/generate-company-stamp`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: companyID ? { companyID } : {}
    });
  },

  // Firma, otomatik üretilen kaşeyi ONAYLAR → stamp_status=2 (sözleşmelerde kullanılır).
  ApproveCompanyStamp(token, companyID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/approve-company-stamp`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: companyID ? { companyID } : {}
    });
  },

  // Firma imzası/kaşesi onay-red (admin). mark: "signature" | "stamp"
  ReviewCompanyMark(token, companyID, mark, approved, rejectionReason = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/review-company-mark`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { companyID, mark, approved: Boolean(approved), ...(rejectionReason ? { rejectionReason } : {}) }
    });
  },

  RemoveCompanyStamp(token, companyID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-company-stamp`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: companyID ? { companyID } : {}
    });
  },
};

export default servisFirma;
